// extracted by mini-css-extract-plugin
export default {"modal":"ModalDelete_modal__yqPNP","top":"ModalDelete_top__NB47z","text":"ModalDelete_text__nEJla","buttons_block":"ModalDelete_buttons_block__66kQL"};